import {getInsightsUrl} from '@github-ui/api-insights-tracing'

import {usePageDataContext} from '../contexts/PageDataContext'
import type {PageDataName} from '../payloads/page-data'

export function pageDataUrl(basePageDataUrl: string, pageDataName: PageDataName, params?: string) {
  return pageDataUrlWithSuffix(basePageDataUrl, pageDataName, undefined, params)
}

export function pageDataUrlWithSuffix(
  basePageDataUrl: string,
  pageDataName: PageDataName,
  pathSuffix?: string,
  params?: string,
) {
  let baseUrl = `${basePageDataUrl}/page_data/${pageDataName}`
  if (pathSuffix) baseUrl += `/${pathSuffix}`
  if (params) baseUrl += `?${params}`

  return getInsightsUrl(baseUrl)
}

export function usePageDataUrl(pageDataName: PageDataName, params?: string) {
  const {basePageDataUrl} = usePageDataContext()
  return pageDataUrl(basePageDataUrl, pageDataName, params)
}
